export class FramerateLimiter {
    constructor(animationFunction, fps = 30) {
        this.animationFunction = animationFunction;
        this.fps = fps;
        this.requestId = 0;
        this.running = false;
    }
    start() {
        if (this.running) {
            throw new Error('animationLoop is already running');
        }
        let then = performance.now();
        const interval = 1000 / this.fps;
        const tolerance = 0.1;
        const animateLoop = (now) => {
            this.requestId = requestAnimationFrame(animateLoop);
            const delta = now - then;
            if (delta >= interval - tolerance) {
                then = now - (delta % interval);
                this.animationFunction(delta);
            }
        };
        this.running = true;
        this.requestId = requestAnimationFrame(animateLoop);
    }
    stop() {
        cancelAnimationFrame(this.requestId);
    }
}
//# sourceMappingURL=framerate_limiter.js.map